import(/* webpackMode: "eager" */ "/app/app/error.tsx");
